import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
`;

export const Header = styled.div`
  height: 50px;
  width: 100%;
  background-color: blue;
  display: flex;
  justify-content: space-between;
`;
